import React from "react";
import { Dialog } from "primereact/dialog";
import { Message } from "primereact/message";
import "./index.css";

type LinkedinCardsDescriptionProps = {
  visible: boolean;
  onHide: () => void;
  description?: string | null;
  title?: string;
};

const LinkedinCardsDescription: React.FC<LinkedinCardsDescriptionProps> = ({
  visible,
  onHide,
  description,
  title,
}) => {
  const hasDescription = !!description && description.trim().length > 0;

  return (
    <Dialog
      header={title ? `Descrição — ${title}` : "Descrição da vaga"}
      visible={visible}
      onHide={onHide}
      modal
      dismissableMask
      style={{ width: "80vw" }}
      contentStyle={{ overflowY: "auto", maxHeight: "70vh" }}
      breakpoints={{ "960px": "75vw", "640px": "95vw" }}
      aria-label="Descrição completa da vaga"
    >
      {hasDescription ? (
        <div
          className="linkedin-card-description"
          dangerouslySetInnerHTML={{ __html: description! }}
        />
      ) : (
        <Message severity="info" text="Sem descrição" />
      )}
    </Dialog>
  );
};

export default LinkedinCardsDescription;
